import { Injectable } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';
import { TranslationService } from '@alfresco/adf-core';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { IWkMessageDialog } from './modal';
import { WKMessageDialogComponent } from '../message-dialog/message.dialog';

@Injectable({
  providedIn: 'root',
})
export class WKMessageDialogService {
  constructor(
    private readonly translationService: TranslationService,
    private readonly dialogRef: MatDialog
  ) {}

  openMessage<T>(
    component: ComponentType<T>,
    data: IWkMessageDialog,
    maxHeight = 250,
    width = 30
  ): MatDialogRef<T> {
    return this.dialogRef.open<T>(component, {
      maxHeight: `${maxHeight}vh`,
      panelClass: 'wk-message-dialog-container',
      width: `${width}%`,
      data: {
        message: this.translate(data.message),
        headerLabel: this.translate(data.headerLabel),
        okLabel: this.translate(data.okLabel),
        cancelLabel: this.translate(data.cancelLabel),
        okLabelClass: data.okLabelClass,
        cancelLabelClass: data.cancelLabelClass,
      },
    });
  }

  private translate(value: string | undefined): string | undefined {
    return value ? this.translationService.instant(value) : undefined;
  }

  public emptyCitationPopup(): void {
    const data = {
      message: 'APP.CITATIONS.EMPTY_REF_MESSAGE',
      headerLabel: 'APP.CITATIONS.EMPTY_REF_HEADER',
      okLabel: 'APP.CITATIONS.ERROR_LABEL',
      okLabelClass: 'wk-button-danger',
    };
    this.openMessage(WKMessageDialogComponent, data, 250, 40);
  }
}
